import { Cookies } from "react-cookie";
import cookiesKeys from "Common/cookies/cookiesKeys";
const removeCookieHunter = () => {
    const cookies = new Cookies();
    cookies.remove(cookiesKeys.hunter);
};
export default removeCookieHunter;
